import { render, staticRenderFns } from "./userLimits.vue?vue&type=template&id=85898420&"
import script from "./userLimits.vue?vue&type=script&lang=ts&"
export * from "./userLimits.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports